import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import modalClose from "../../../../assets/images/modal-close.svg";
import CustomButton from "views/components/common/button/CustomButton";

const CustomModal = ({ modalTitle, visible, handleConfirm, handleCancel, assignedTo }) => {
  const { t } = useTranslation();
  let title = t('deleteConfirmationTitle');
  let content;
  let buttonName = t('delete')
  if (modalTitle === 'treatment'){
    content = t('deleteActionTreatmentContent');
  } else if (modalTitle === 'line-item') {
    content = t('deleteActionItemContent');
  } else if (modalTitle === 'assign') {
    title = t('assignment_confirmation');
    buttonName = t('assign')
    if (assignedTo) {
      content = `${t('assignedTo')} ${assignedTo} ${t('reAssignConfirmation')}`;
    } else {
      content = t('assignmentConfirmation');
    }
  }else if(modalTitle === 'revoke'){
    title = t('revoke_confirmation');
    buttonName = t('revoke')
    content = t('revokeConfirmation');
  } else if(modalTitle === 'resetToInitial'){
    title = t('resetToInitialConfirmationTitle');
    content = t('resetInitialActionContent');
    buttonName = t('reset')
  }else {
    title = t('resetConfirmationTitle');
    content = t('resetActionContent');
    buttonName = t('reset')
  }
  return (
    <Modal
      title={title}
      open={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      footer={null}
      width={400}
      centered={true}
      mask={true}
    >
    <img
      src={modalClose}
      alt="notes"
      className="modal-head-icon"
    />
      <p className="fs14 lh18 mb30 pl25 pr25">{content}</p>
      <div className="footer-modal d-flex gap-3 mt-2 ml25 mr25">
      <CustomButton
          label={t("cancel")}
          type="primary"
          htmlType="submit"
          className="btn-white w-100 br8 h38"
          navigate={false}
          key="reset"
          onClick={handleCancel}
        />
          <CustomButton
          label={t(buttonName)}
          type="primary"
          htmlType="submit"
          className="btn-blue w-100 br8 h38"
          navigate={false}
          key="reset"
          onClick={handleConfirm}
        />
      </div>
    </Modal>
  );
};

export default CustomModal;
